export interface IInvoiceModel {
  id?: string;
  url?: string;
  name?: string;
  dropbox?: string;
  creationDate?: string;
  fileDate?: string;
}

export interface IInvoicesConfigModel {
  disclaimer_message: string;
}

export enum Sorting {
  asc = 'ASC',
  desc = 'DESC',
  def = 'DEF'
}
